import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'kt-form-subm-warning-modal',
  templateUrl: './form-subm-warning-modal.component.html',
  styleUrls: ['./form-subm-warning-modal.component.scss']
})
export class FormSubmWarningModalComponent implements OnInit {
  @Input() title: string;
  @Input() messages: string[] = [];
  @Input() btnOkText: string;
  @Input() btnCancelText: string;

  constructor(private activeModal: NgbActiveModal) {}

  ngOnInit() {}

  public decline() {
    this.activeModal.close(false);
  }

  public accept() {
    this.activeModal.close(true);
  }

  public dismiss(type) {
    this.activeModal.dismiss(type);
  }
}
